(function($, undefined) {
	'use strict';
	var utils;
    var headNav;
    var infoBox;
    var infoBoxCtn;
    var infoBoxInner;
    var eventHeader;

	var showWebTab = function() {
		var btn = $(this);
		var target = $('.event-details__left-content-box').offset().top;
		
		$('.event-details__register-choice').each(function() {
            if (this.value === 'web') {
                this.checked = true;
                $(this).trigger('change');
            } else {
                this.checked = false;
            }
        });
		
		if (!utils.isSM() && $(window).scrollTop() < target) {
			target = target - $('.site-header__bottom').outerHeight();
		}

		target = target - 40;

		$('html, body').animate({ scrollTop: target }, 500);
	};
    
    function chooseTab(e) {
        var cb = e.currentTarget;
        var ctn = $(cb).closest('.event-details__tab-content');
        
        if (cb.checked) {
            ctn.attr('data-id', cb.value);
            ctn.find('.event-details__choice-info:not([data-parent-id=' + cb.value + '])').hide();
            ctn.find('.event-details__choice-info[data-parent-id=' + cb.value + ']').show();
        }
    }
    
    function stickyInfoBox() {
        if (window.innerWidth >= 768) {
            const navH = headNav.outerHeight();
            const navPosTop = headNav.position().top;
            const offsetY = headNav.offset().top + navH;
            const topLimitY = eventHeader.offset().top;
            const parentY = infoBoxCtn.offset().top;
            const h = infoBoxInner.outerHeight();
            let y = 0;

            if (offsetY <= topLimitY) {
                // Top limit, scrolling position upward and at the top
                y = topLimitY - parentY;
                infoBox[0].style.top = y + 'px';
                infoBoxInner[0].style.top = '';
                infoBoxInner[0].style.position = '';
            } else {
                // Scrolling position downward and reaching the bottom of the content body
                const parentH = infoBoxCtn.outerHeight();
                const bottomLimitY = parentY + parentH;

                if (offsetY + h < bottomLimitY) {
                    // Mid range
                    //y = offsetY - parentY - 1;
                    y = navH + navPosTop;
                } else {
                    // Lowest limit
                    //y = parentH - h;
                    y = bottomLimitY - (offsetY + h) + navH + navPosTop;
                }
                infoBoxInner[0].style.top = y + 'px';
                infoBoxInner[0].style.position = 'fixed';
            }
            //infoBox[0].style.transform = 'translate3d(0,' + (((y) / h) * 100) + '%,0)'; Translate3d method is jaggy and jumpy while scrolling, use position:fixed instead
            infoBoxInner[0].style.width = infoBox.innerWidth() + 'px';
        } else {
            infoBoxInner[0].style = '';
        }

        window.requestAnimationFrame(stickyInfoBox);
    }

	var init = function() {
		utils = Fw.component.models().utils;

		$('.event-details__webdiffusion-btn').click(showWebTab);
        $('.event-details__register-choice').on('change', chooseTab);
	};

	$(window).ready(init);
    
    document.addEventListener('DOMContentLoaded', (event) => {
        // Initiate sticky info box
        infoBox = $('.event-details__left-content');
        if (infoBox[0]) {
            infoBoxCtn = infoBox.offsetParent();
            infoBoxInner = infoBox.children().eq(0);
            eventHeader = $('.event-details__header').children().eq(0);
            headNav = $('.site-header');
            infoBox.addClass('initiated');
            window.requestAnimationFrame(stickyInfoBox);
        }
    });
})(jQuery);
